
import {
  dispatchGetFirstLineUsers,
  dispatchGetFirstLineUsersForUser,
  dispatchGetUserPurchases,
  dispatchGetReferralStructureInfo, 
  dispatchGetMonthlyTurnover,
  dispAuthFetch,
} from "@/store/mlm/actions";
import {
  readToggledTreeIds,
  readTreeUsersChildren,
  readUserRefInfo,
  readUserMonthlyTurnover,
} from "@/store/mlm/getters";
import {IUserPurchases} from "@/interfaces/mlm"
import {TreeFiltersModel} from "./TeamTreeFilter.vue";
import {readUserProfile} from "@/store/main/getters";
import {
  commitSetToggledTreeIds,
  commitSetTreeUsersChildren,
} from "@/store/mlm/mutations";
import { Component, Prop, Vue } from "vue-property-decorator";
import ChildTreeTable from "./ChildTreeTable.vue";
import { mask } from "vue-the-mask";
import TeamTreeFilter from "./TeamTreeFilter.vue";
import UserInfoModal from "./UserInfoModal.vue";
import ReferralTableList from "./ReferralTableList.vue";
import IconArrow from "./IconArrow.vue";
import UiSmallLoader from "../Ui/UiSmallLoader.vue";

@Component({
  directives: { mask },
  components: {
    ChildTreeTable,
    TeamTreeFilter,
    UserInfoModal,
    ReferralTableList,
    IconArrow,
    UiSmallLoader
  },
})
export default class ListTeamTree extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isBitbook!: boolean;

  public usersRepsonse: any = {
    current: 0,
    count: 0,
    total: 0,
    next: null,
    previous: null,
    results: [],
  };
  public page: number = 1;
  public loadingState: boolean = true;
  public showFilters: boolean = false;
  public filters: any = {
    search: "",
    date_joined_from: "",
    date_joined_to: "",
    users_count_first_line_min: null,
    users_count_first_line_max: null,
    level_min: null,
    level_max: null,
  };
  public refUserInfo: any = null;
  public user: any = null;
  public userTeam = []
  public isShowTeamLevels = false
  public isShowTeamLevels2 = false

  public isShowUserInfoId = 0;
  public loadingPurchases = false;
  public userPurchases:IUserPurchases[] = []

  public pageChild = 1;
  public currentUserChild: null | number = null;
  public loadingStateChild: boolean = false;
  public childUsersRepsonse: any = {
    current: 0,
    count: 0,
    total: 0,
    next: null,
    previous: null,
    results: [],
  };

  public async mounted() {
    commitSetTreeUsersChildren(this.$store, {});
    commitSetToggledTreeIds(this.$store, []);
    this.handleChangePage(1, true);
    await dispatchGetReferralStructureInfo(this.$store, {});
    await dispatchGetMonthlyTurnover(this.$store)

    this.user = readUserProfile(this.$store);
    // await this.handleTeamLevels()
    document.addEventListener("click", this.handleClickOutside)
    document.addEventListener("click", this.handleClickOutside2)
  }

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("click", this.handleClickOutside2);
  }
  /** Need or Not? */
  // public async handleTeamLevels() {
  //   const invoiceResp = await dispAuthFetch(this.$store, {
  //     input: "/api/v1/mlm/node-count-by-level/",
  //     init: {
  //       method: "GET",
  //     },
  //   });

  //   if (invoiceResp.status === 200) {
  //     this.userTeam = await invoiceResp.json()
  //   }
  // }

  handleClickOutside(event) {
    const getElement = (ref) => {
      if (!ref) return null;
      if (ref instanceof HTMLElement) return ref;
      if (ref.$el instanceof HTMLElement) return ref.$el;
      return null;
    };

    const hiddenBlock = getElement(this.$refs.hiddenBlock);
    if(this.isShowTeamLevels && !event.target.classList.contains('ignoreClick')) {
      if (!hiddenBlock.contains(event.target)) {
        this.isShowTeamLevels = false;
      }
    }
  }

  handleClickOutside2(event) {
    const getElement = (ref) => {
      if (!ref) return null;
      if (ref instanceof HTMLElement) return ref;
      if (ref.$el instanceof HTMLElement) return ref.$el;
      return null;
    };

    const hiddenBlock = getElement(this.$refs.hiddenBlock2);
    if(this.isShowTeamLevels2 && !event.target.classList.contains('ignoreClick')) {
      if (!hiddenBlock.contains(event.target)) {
        this.isShowTeamLevels2 = false;
      }
    }
  }

  public async handleChangeFilters() {
    // console.log("filters from TreeFilters:", this.filters);
    this.showFilters = false;
    this.handleChangePage(1, true);
  }
  public async handleChangeFiltersBitbook(newFilters: TreeFiltersModel) {
    this.filters = { ...newFilters }; // обновляем родительский filters
    this.showFilters = false;
    this.handleChangePage(1, true);
  }
  public async handleResetFilters() {
    this.filters = {
      search: "",
      date_joined_from: "",
      date_joined_to: "",
      users_count_first_line_min: null,
      users_count_first_line_max: null,
      level_min: null,
      level_max: null,
    };
    this.handleChangeFilters();
  }

  public async handleResetFiltersBitbook() {
    this.filters = {
      search: "",
      date_joined_from: "",
      date_joined_to: "",
      users_count_first_line_min: null,
      users_count_first_line_max: null,
      level_min: null,
      level_max: null,
    };
    this.handleChangePage(1, true);
  }
  

  public async handleChangePage(page, force = false) {
    if (this.page !== page || force) {
      this.page = page;
      const rowQuery = `?page=${this.page}&page_size=20`;
      if (this.filters.users_count_first_line_min === "") {
        this.filters.users_count_first_line_min = null;
      }
      if (this.filters.users_count_first_line_max === "") {
        this.filters.users_count_first_line_max = null;
      }
      this.usersRepsonse = await dispatchGetFirstLineUsers(this.$store, {
        data: this.filters,
        rowQuery,
      });
    }
    this.loadingState = false;
  }

  public getStructureClass(id, hasChildren) {
    if (hasChildren) {
      if (this.toggledTreeIds.includes(id)) {
        return "tree__open tree__open_close";
      } else {
        return "tree__open";
      }
    } else {
      return "";
    }
  }

  public async toggleTeamItems(user, level) {
    const toggledTreeIds = this.toggledTreeIds;
    const userId = user.user.id;

    if (toggledTreeIds.includes(userId)) {
      // @ts-ignore
      const index = toggledTreeIds.indexOf(userId);
      if (index > -1) {
        toggledTreeIds.splice(index, 1);
      }
     // рекурсивно закрываем всех потомков
      this.closeChildren(userId);
    } else {

      toggledTreeIds.push(userId);
     

      if (!(userId in this.treeUsersChildren)) {
      const rowQuery = `?page=${this.pageChild}&page_size=20`;
      let children = await dispatchGetFirstLineUsersForUser(this.$store, {
        data:{user: userId,
        product: null,},
        rowQuery
      });
     
      // console.log("user: userId list team", userId)
      let treeUsersChildren = { ...this.treeUsersChildren };
      treeUsersChildren[userId] = children;
      commitSetTreeUsersChildren(this.$store, treeUsersChildren);
    } 

    }
    
  }

  public async handleShowUserInfoByID(userId){
   if (userId && userId === this.isShowUserInfoId) {
    this.isShowUserInfoId = 0  // если кликнули повторно
  } else if (userId) {
    this.isShowUserInfoId = userId  // открыть новый
    this.loadingPurchases = true
      try {
        this.userPurchases = await dispatchGetUserPurchases(this.$store,{user_id: userId})
      } finally {
        this.loadingPurchases = false
      }
  } 
  }
  public getFullName(fName, lName) {
    return `${fName} ${lName ? lName : ""}`;
  }

  get toggledTreeIds() {
    return readToggledTreeIds(this.$store);
  }

  public isLastToggled(id) {
    if (this.toggledTreeIds.includes(id)) {
      return this.toggledTreeIds[this.toggledTreeIds.length - 1] === id;
    }
    return false;
  }

public closeChildren(userId: number, treeCache?: any) {
  // Берём переданный кеш или создаём копию один раз
  const treeUsersChildren = treeCache ?? { ...this.treeUsersChildren };
  
  if (userId in treeUsersChildren) {
    const children = treeUsersChildren[userId].results || [];
    
    children.forEach((child) => {
      const childId = child.user.id;
      
      const idx = this.toggledTreeIds.indexOf(childId);
      if (idx > -1) {
        this.toggledTreeIds.splice(idx, 1);
      }
      
      // Передаём тот же объект вглубь, не создаём новый
      this.closeChildren(childId, treeUsersChildren);
    });

    delete treeUsersChildren[userId];
    
    // Коммитим только на верхнем уровне (когда treeCache не передан)
    if (!treeCache) {
      commitSetTreeUsersChildren(this.$store, treeUsersChildren);
    }
  }
}

  get treeUsersChildren() {
    return readTreeUsersChildren(this.$store);
  }

  get refInfo() {
    return readUserRefInfo(this.$store);
  }

  get userMonthlyTurnover() {
    return readUserMonthlyTurnover(this.$store)
  }

  get nodesInTenLines(){
    const a = this.refInfo?.ph_node_purchases_count_in_ten_lines || 0
    const b = this.refInfo?.v_node_purchases_count_in_ten_lines || 0
    return a + b
  }

  get nodesInTeam(){
    const a = this.refInfo?.ph_node_purchases_count || 0
    const b = this.refInfo?.v_node_purchases_count || 0
    return a + b
  }

  public totalPurchases(item) {
    return (item.ph_node_purchases_count || 0) 
      + (item.v_node_purchases_count || 0) 
      + (item.ring_purchases_count || 0)
  }
}
